import React, { useState, useEffect, use } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useSubscriptions } from '../Subscriptions/fetchApi'
import { useUserActions } from '../Users/connectApi/users'
import { DateObject } from 'react-multi-date-picker'
import persian_fa from "react-date-object/locales/persian_fa";
import persian from "react-date-object/calendars/persian";
import { setSelectionRange } from '@testing-library/user-event/dist/utils'
import FormatPrice from '../../components/FormatPrice/FormatPricw'
import Num2persian from 'num2persian'
import ConvertPersianToEnglish from '../../components/ConvertNumberToEnglish'
import { Pagination } from 'antd'
const EditSubscriberWallet = () => {
    const navigate = useNavigate()
    const { getUserInit } = useSubscriptions((state) => state.actions)
    const { editWalletDetail, getWalletByUserId, getWalletBalanceByUserId } = useUserActions((state) => state.actions)
    const walletByUserId = useUserActions((state) => state.walletByUserId)
    const userInit = useSubscriptions((state) => state.userInit)
    const walletBalance = useUserActions((state) => state.walletBalance)
    const walletByUserPagination = useUserActions((state) => state.walletByUserPagination)
    const params = useParams()
    const [description, setDescription] = useState("")
    const [price, setPrice] = useState(null)
    const [transType, setTransType] = useState(1)
    const [page, setPage] = useState(1)
    useEffect(() => {
        getUserInit(params.id)
        getWalletBalanceByUserId(params.id)
    }, [])
    console.log(walletByUserPagination, "walletByUserPagination walletByUserPagination ");


    const getStatusStyle = (status) => {
        return status === 1 ? 'text-green-600 font-medium' : 'text-red-500 font-medium';
    };
    const editWalletDetailHandler = async () => {
        await editWalletDetail(Number(params.id), 0, Number(price), description, transType)
        getWalletBalanceByUserId(params.id)
        setPrice(null)
        setDescription("")
    }
    const handlePageChange = (page) => {
        setPage(page)
    }
    useEffect(() => {
        getWalletByUserId(
           /*  userId, */params?.id,
           /*  paymentFor, */null,
            /* amountFrom, */null,
          /*   amountTo, */null,
           /*  transactionDateFrom, */null,
            /* transactionDateTo, */null,
            /* transType, */null,
           /*  status, */null,
           /*  result, */null,
           /*  page */page

        )
    }, [page])
    return (
        <div>

            <img src='/icons/backToSubs.svg' alt='' onClick={() => navigate('/Subscriptions')} className='mb-5' />
            <div className='font-bold '>{userInit?.firstName} {userInit?.lastName}

            </div>
            <div className='text-[#747474]'>
                {userInit?.mobileNumber}
            </div>


            <div className='grid  grid-cols-7 gap-2 pb-20'>

                <div className="  col-span-5 overflow-x-hidden rounded-lg border border-gray-200 shadow-sm">
                    <table className="min-w-full text-sm  rtl:text-right ">
                        <thead className="bg-gray-100 text-gray-700">
                            <tr className="border-b">
                                <th className="px-4 py-3 border border-[#B9B9B9]">ردیف</th>
                                <th className="px-4 py-3 border border-[#B9B9B9]">بابت</th>
                                <th className="px-4 py-3 border border-[#B9B9B9]">تاریخ</th>
                                <th className="px-4 py-3 border border-[#B9B9B9]">ساعت</th>
                                <th className="px-4 py-3 border border-[#B9B9B9]">مبلغ</th>
                                <th className="px-4 py-3 border border-[#B9B9B9]">نوع تراکنش</th>
                                <th className="px-4 py-3 border border-[#B9B9B9]">وضعیت</th>
                                <th className="px-4 py-3 border border-[#B9B9B9]">شماره پیگیری تراکنش</th>
                            </tr>
                        </thead>
                        <tbody>
                            {walletByUserId?.map((item, index) => (
                                <tr key={index} className="border-b hover:bg-gray-50 text-center text-[#747474]">
                                    <td className="px-4 py-2  border border-[#B9B9B9]">{index + 1}</td>
                                    <td className="px-4 py-2 border border-[#B9B9B9]">{item.paymentFor}</td>
                                    <td className="px-4 py-2 border border-[#B9B9B9]"> {new DateObject(item.dateTime && item.dateTime.slice(0, 10)).convert(persian, persian_fa).format()}</td>
                                    <td className="px-4 py-2 border border-[#B9B9B9]">{item.dateTime && item?.dateTime?.split("T")[1].split(":").slice(0, 2).join(":")}</td>
                                    <td className="px-4 py-2 border border-[#B9B9B9]">{item.amount}</td>
                                    <td className="px-4 py-2 border border-[#B9B9B9]">{item.transType === 1 ? `واریز` : ` برداشت`}</td>
                                    <td className={`px-4 py-2 border border-[#B9B9B9] ${getStatusStyle(item.status)}`}>
                                        {item.status === 1 ? `موفق` : ` ناموفق`}
                                    </td>
                                    <td className="px-4 py-2 border border-[#B9B9B9]">{item.paymentTrackId}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="col-span-2 max-h-[460px] rounded-lg border border-[#B9B9B9] p-4 space-y-4 text-right font-vazir">
                    {/* Header */}
                    <div className="flex justify-between items-center">
                        <span className="font-bold text-lg">کیف پول</span>
                        <span className="text-sm text-gray-700">
                            موجودی: <span className="font-semibold">    {walletBalance && walletBalance.totalAmount && walletBalance.totalAmount.toLocaleString()} </span>
                        </span>
                    </div>

                    {/* مبلغ Input */}
                    <div>
                        <label htmlFor="amount" className="block mb-1 text-sm font-medium">
                            مبلغ
                        </label>
                        <div className="flex items-center bg-gray-100 rounded-lg overflow-hidden">
                            <span className="px-3 py-2 text-gray-500 text-sm bg-gray-200 border-l border-gray-300">
                                تومان
                            </span>
                            <input
                                type="number"
                                id="amount"
                                name="amount"
                                value={price}
                                // onChange={(e) => setPrice(e.target.value)}
                                onChange={(e) => {
                                    let rawValue = ConvertPersianToEnglish(e.target.value);
                                    rawValue = rawValue.replace(/[^0-9,]/g, ""); // Allow commas
                                    setPrice(rawValue.replace(/,/g, "")); // Save raw number without commas
                                }}
                                className="w-full px-3 py-2 bg-gray-100 focus:outline-none text-sm"
                            />

                        </div>
                        {price ? (
                            <p className="px-3 text-[12px] text-green-600">
                                {Num2persian(price)} تومان
                            </p>
                        ) : null}
                    </div>


                    <div className="space-y-2">
                        <div className="flex items-center gap-2">
                            <input
                                onChange={() => setTransType(-1)}
                                type="radio"
                                id="decrease"
                                name="changeType"
                                value="decrease"
                                defaultChecked
                                className="accent-green-600 w-4 h-4"
                            />
                            <label htmlFor="decrease" className="text-sm">کاهش</label>
                        </div>
                        <div className="flex items-center gap-2">
                            <input
                                type="radio"
                                id="increase"
                                name="changeType"
                                value="increase"
                                className="accent-green-600 w-4 h-4"
                                onChange={() => setTransType(1)}
                            />
                            <label htmlFor="increase" className="text-sm">افزایش</label>
                        </div>
                    </div>

                    {/* شرح */}
                    <div>
                        <label htmlFor="description" className="block mb-1 text-sm font-medium">شرح</label>
                        <textarea
                            id="description"
                            name="description"
                            rows="3"
                            className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none text-sm"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>

                    {/* Submit Button */}
                    <div className="text-center">
                        <button className="font-bold border border-[#227934] text-black px-6 py-2 rounded-lg hover:bg-green-50" onClick={() => editWalletDetailHandler()}>
                            اعمال
                        </button>
                    </div>
                </div>
                <div className='fixed w-full z-10 bottom-0 bg-white py-1  flex justify-center pl-[23%] mt-7'>
                    <Pagination
                        current={page}
                        total={walletByUserPagination.total}
                        pageSize={20}
                        onChange={handlePageChange}
                        showSizeChanger={false}
                    />
                </div>
            </div>
        </div>
    )
}

export default EditSubscriberWallet